// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1fd90","left":"InfoRow_left__3IVq_"};